import React from 'react';
import type { ChangeEvent } from 'react';
import { Input } from '../../../../shared/components/ui/Input';
import { Box, InputAdornment, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import type { rest } from 'lodash';


interface InputFieldProps{
  label: string;
  type: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  error?: boolean;
  errorMessage?: string;
  placeholder: string;
  icon: React.ReactNode;
  disabled?: boolean;
  showPasswordToggle?: boolean;
  onTogglePassword?: () => void;
  showPassword?: boolean;
  autoComplete?: string;
}

export const InputField: React.FC<InputFieldProps> = ({
  label,
  type,
  value,
  onChange,
  onBlur,
  error,
  errorMessage,
  placeholder,
  icon,
  disabled,
  showPasswordToggle,
  onTogglePassword,
  showPassword,
  autoComplete,
}) => {
  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Input
        fullWidth
        label={label}
        type={type}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        helperText={error && errorMessage}
        autoComplete={autoComplete}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {icon}
            </InputAdornment>
          ),
          endAdornment: showPasswordToggle ? (
            <InputAdornment position="end">
              <IconButton
                onClick={onTogglePassword}
                edge="end"
                disabled={disabled}
                tabIndex={-1}
              >
                { showPassword ? <VisibilityOffIcon/> : <VisibilityIcon /> }
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#F9FAFB',
          },
        }}
      />
    </Box>
  );
}; 